import { render, staticRenderFns } from "./TableauInscritsPaginated.vue?vue&type=template&id=0a58db4d&"
import script from "./TableauInscritsPaginated.vue?vue&type=script&lang=js&"
export * from "./TableauInscritsPaginated.vue?vue&type=script&lang=js&"
import style0 from "./TableauInscritsPaginated.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports